import { Component, OnInit } from '@angular/core';
import { InventarioService } from 'src/app/services/inventario.service';
import Swal from 'sweetalert2';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { viaticosService } from 'src/app/services/viaticos.service';
import { ExcelService } from '../../../services/excel.service';

declare var $: any;
interface XMLPartida {
  folio: string;
  subtotal: number;
  total: number;
  descuento?: number;
  base16?: number;
  iva16?: number;
  base0?: number;
  impuestos?: number;
  isr?: number;
  rfc_emisor: string;
  nombre_emisor: string;
  rfc_receptor: string;
  nombre_receptor: string;
  uuid: string;
  no_certificado_sat: string;
  fecha_sat: string;

  buenoPor: number;
  restante: number;
}

@Component({
  selector: 'app-listadxmlfinancieros',
  templateUrl: './listadxmlfinancieros.component.html',
  styleUrls: ['./listadxmlfinancieros.component.css']
})
export class ListadxmlfinancierosComponent implements OnInit {

 datos = JSON.parse(localStorage.getItem('datos')!);
  noplantel = this.datos.idplantel;

  xmllista: any = [];
  xmlPreview: any = {};   
  partidas: any[] = [];
  modo: 'nuevo' | 'editar' | 'ver' = 'nuevo';
  partidaActual = {
    clave: '',
    xmls: [] as XMLPartida[]

  };
  observa: any = [];
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  empleados: any = [];
  planteles: any = [];
  empleadoSeleccionado: any = null;
  busquedaEmpleado: string = '';
  empleadosFiltrados: any[] = [];
  comprobacionesAgrupadas: any[] = [];
  comprobacion: any = [];
  general: any = [];

  idComprobacion: number | null = null;
  viaticos = {
    plantel: '',
    oficio: '',
    cargoBancario: '',
    subsidio: '',
    comisionado: '',
    motivo: '',
    lugar: '',
    fechaIda: '',
    fechaRegreso: '',
    importecb: '',
    Comprobado: 0,
    Reintegro: 0,
    fechaReintegro: '',
    buenopor:0
  };
  catalogoPartidas = [
    { clave: '2610-0002', descripcion: 'Combustibles, lubricantes y aditivos estatal' },
    { clave: '2610-0003', descripcion: 'Combustibles, lubricantes y aditivos federal' },
    { clave: '3720-0001', descripcion: 'Pasajes nacionales' },
    { clave: '3750-0001', descripcion: 'Viáticos nacionales (alimentos, hospedaje)' },
    { clave: '3790-0001', descripcion: 'Traslados locales' },
    { clave: '3710-0001', descripcion: 'Pasajes nacionales (Aéreo)' },
    { clave: '4430-0001', descripcion: 'Otros subsidios educacionales' },
    { clave: '4450-0004', descripcion: 'Subsidios a sindicatos' }

  ];
  subsidio = [
    { descripcion: 'Ingreso estatal' },
    { descripcion: 'Ingreso federal' },
    { descripcion: 'Ingreso propios' },

  ];

  constructor(
    private inventarioService: InventarioService,
    private viaticosService: viaticosService,
    private msj: mensajeSesionExpiradaService,
    private excelService: ExcelService ,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',

      ordering: false,

      autoWidth: false,

      searching: true,

      responsive: false,

      columnDefs: [
        {
          targets: '_all',
          orderable: false
        }
      ],

      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json'
      }
    };
    this.getXMLlista();
    this.traerDatosplantel();
  }

  get montoReintegro(): number {
    return Math.abs(Number(this.viaticos.Reintegro) || 0);
  }
  getXMLlista() {
    this.viaticosService.Listafacturasfinancieros(this.noplantel).subscribe(
      res => {
        console.log(res)

        if (res === "TOKEN-EXPIRADO") {
          this.msj.tokenExpiradoCerrarSesion();
          return;
        }

        this.xmllista = res;

        const agrupado = this.xmllista.reduce((acc: any, item: any) => {

          if (!acc[item.id]) {

            acc[item.id] = {
              id: item.id,
              nombreplantel: item.nombreplantel,
              oficio: item.oficio,
              numempleado: item.numempleado,
              nombre: item.nombre,
              observacion: item.observacion,
              origen: item.origen,
              expandido: false,

              detalles: []
            };
          }

          acc[item.id].detalles.push(item);

          return acc;

        }, {});

        this.comprobacionesAgrupadas = Object.values(agrupado);
        if ($.fn.dataTable.isDataTable('.tabla-asignaturas')) {
          $('.tabla-asignaturas').DataTable().destroy();
        }

        setTimeout(() => {
          this.dtTrigger.next();
        }, 0);

      },
      err => {
        console.error(err);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al cargar la tabla'
        });
      }
    );
  }
  toggleDetalle(item: any) {
    item.expandido = !item.expandido;
  }
  abrirAgregarXML() {
    this.busquedaEmpleado = '';
    this.empleadosFiltrados = [];
    this.empleadoSeleccionado = null;

    this.viaticos = {
      plantel: '',
      oficio: '',
      cargoBancario: '',
      subsidio: '',
      comisionado: '',
      motivo: '',
      lugar: '',
      fechaIda: '',
      fechaRegreso: '',
      importecb: '',
      Comprobado: 0,
      Reintegro: 0,
      fechaReintegro: '',
      buenopor:0
    };

    this.partidas = [];
    this.partidaActual = {
      clave: '',
      xmls: []
    };

    $('#Agrexml').modal('show');
  }


  cerrarAgregarXML() {
    $('#Agrexml').modal('hide');
  }

  cerrarPreviewXML() {
    $('#previewXML').modal('hide');
  }
  abrirModalPartida() {
    this.partidaActual = {
      clave: '',
      xmls: []
    };
    $('#modalPartida').modal('show');
  }

  cerrarModalPartida() {
    $('#modalPartida').modal('hide');
  }






  onFileSelectedPartida(event: any) {
    const input = event.target as HTMLInputElement;
    const files: FileList | null = input.files;

    if (!files || !files.length) return;

    this.procesarArchivosXML(files);

    input.value = '';
  }


  onDropPartida(event: DragEvent) {
    event.preventDefault();

    if (event.dataTransfer?.files) {
      this.procesarArchivosXML(event.dataTransfer.files);
    }
  }
  eliminarXMLPartida(index: number) {
    this.partidaActual.xmls.splice(index, 1);
    this.actualizarComprobacionYReintegro();
  }

  existeUUID(uuid: string): boolean {
    if (this.partidaActual.xmls.some((x: any) => x.uuid === uuid)) {
      return true;
    }

    return this.partidas.some(p =>
      p.xmls.some((x: any) => x.uuid === uuid)
    );
  }
  procesarArchivosXML(files: FileList) {
    if (!this.partidaActual.clave) {
      Swal.fire(
        'Partida requerida',

        'Debes capturar la clave de la partida antes de agregar XML',
        'warning'
      );
      return;
    }

    const xmlsCargados: any[] = [];
    const promesas: Promise<void>[] = [];

    Array.from(files).forEach(file => {
      if (!file.name.toLowerCase().endsWith('.xml')) return;

      const reader = new FileReader();

      const promesa = new Promise<void>((resolve) => {
        reader.onload = () => {
          const xmlText = reader.result as string;
          this.parseXML(xmlText);

          if (this.existeUUID(this.xmlPreview.uuid)) {
            resolve();
            return;
          }

          xmlsCargados.push({
            ...this.xmlPreview,
            subtotal: Number(this.xmlPreview.subtotal),
            total: Number(this.xmlPreview.total),
            partida: this.partidaActual.clave
          });

          resolve();
        };

        reader.readAsText(file);
      });

      promesas.push(promesa);
    });

    Promise.all(promesas).then(() => {

      const payload = {
        empleado: this.empleadoSeleccionado, 
        viaticos: this.viaticos, 
        partidas: [
          {
            clave: this.partidaActual.clave,
            xmls: xmlsCargados
          }
        ]
      };

      this.viaticosService.Verificalinea(payload).subscribe({
        next: (resp: any) => {

          const resultados = resp.conRestante;

          let mensajes: string[] = [];
          let xmlsValidos: any[] = [];

          resultados.forEach((r: any) => {

            const xmlOriginal = xmlsCargados.find(x => x.uuid === r.uuid);

            if (!xmlOriginal) return;

            if (r.mensaje.includes('Disponible')) {
              const maximo = r.restante > 0 ? r.restante : xmlOriginal.total;

              xmlsValidos.push({
                ...xmlOriginal,
                maximo: maximo,
                buenoPor: maximo,
                restante: maximo,

                numeroFactura: r.numerofactura ?? '',
                isr: r.isr ?? 0,
                tipoPersona: r.tipopersona ?? '',
                codigoPostal: r.codigopostal ?? '',
                observacion: r.observacion ?? 'NO COMPARTIDA'
              });
            } else {
              mensajes.push(`UUID ${r.uuid}: ${r.mensaje}`);
            }

          });

          this.partidaActual.xmls.push(...xmlsValidos);

          Swal.fire({
            title: 'Resultado de validación',
            html: `
            <b>XML válidos:</b> ${xmlsValidos.length}<br><br>
            <b>Observaciones:</b><br>
            ${mensajes.length ? mensajes.join('<br>') : 'Todos los XML son válidos'}
          `,
            icon: mensajes.length ? 'warning' : 'success'
          });

        },
        error: (err) => {
          console.error('Error completo:', err);

          Swal.fire(
            'Error',
            err?.error?.message || 'Ocurrió un error al verificar los XML',
            'error'
          );
        }
      });

    });
  }
  filtrarEmpleados() {

    const texto = this.busquedaEmpleado.toLowerCase().trim();

    if (!texto) {
      this.empleadosFiltrados = [];
      return;
    }

    this.empleadosFiltrados = this.empleados.filter((emp: any) => {

      const nombreCompleto =
        `${emp.nombre} ${emp.appaterno} ${emp.apmaterno}`.toLowerCase();

      return (
        nombreCompleto.includes(texto) ||
        emp.numpersonal?.toString().includes(texto)
      );

    });

  }
  seleccionarEmpleado(emp: any) {

    this.empleadoSeleccionado = emp;

    this.busquedaEmpleado =
      `${emp.numpersonal} - ${emp.nombre} ${emp.appaterno} ${emp.apmaterno}`;

    this.empleadosFiltrados = [];

  }

  confirmarPartida() {
    if (!this.partidaActual.clave || !this.partidaActual.xmls.length) return;

    this.partidas.push({
      clave: this.partidaActual.clave,
      xmls: [...this.partidaActual.xmls]
    });

    this.partidaActual = {
      clave: '',
      xmls: []
    };
    this.actualizarComprobacionYReintegro();
  }


  parseXML(xmlString: string) {

    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlString, "text/xml");

    const comprobante = xml.getElementsByTagName("cfdi:Comprobante")[0];
    const emisor = xml.getElementsByTagName("cfdi:Emisor")[0];
    const receptor = xml.getElementsByTagName("cfdi:Receptor")[0];
    const timbre = xml.getElementsByTagName("tfd:TimbreFiscalDigital")[0];

    const traslados = xml.getElementsByTagName("cfdi:Traslado");
    const retenciones = xml.getElementsByTagName("cfdi:Retencion");

    let subtotal = parseFloat(comprobante?.getAttribute("SubTotal") || "0");
    let totalXML = parseFloat(comprobante?.getAttribute("Total") || "0");
    let descuento = parseFloat(comprobante?.getAttribute("Descuento") || "0");

    let base16 = 0;
    let iva16 = 0;
    let base0 = 0;
    let impuestos = 0;
    let isrRetenido = 0;
    const impuestosLocales = xml.getElementsByTagName("implocal:ImpuestosLocales")[0];

    let trasladosLocales = 0;
    let retencionesLocales = 0;

    if (impuestosLocales) {
      trasladosLocales = parseFloat(
        impuestosLocales.getAttribute("TotaldeTraslados") || "0"
      );

      retencionesLocales = parseFloat(
        impuestosLocales.getAttribute("TotaldeRetenciones") || "0"
      );
    }
   
    for (let i = 0; i < traslados.length; i++) {

      const tasa = traslados[i].getAttribute("TasaOCuota");
      const base = parseFloat(traslados[i].getAttribute("Base") || "0");
      const importe = parseFloat(traslados[i].getAttribute("Importe") || "0");

      impuestos += importe;

      if (tasa === "0.160000") {
        base16 += base;
        iva16 += importe;
      }

      if (tasa === "0.000000") {
        base0 += base;
      }
    }


    for (let i = 0; i < retenciones.length; i++) {

      const impuesto = retenciones[i].getAttribute("Impuesto");
      const importe = parseFloat(retenciones[i].getAttribute("Importe") || "0");

      if (impuesto === "001") { 
        isrRetenido += importe;
      }
    }

    const totalCalculado =
      subtotal + impuestos + trasladosLocales - isrRetenido - retencionesLocales - descuento;

    this.xmlPreview = {
      folio: comprobante?.getAttribute("Folio") || '',
      subtotal: +subtotal.toFixed(2),
      descuento: +descuento.toFixed(2),

      total: +totalXML.toFixed(2), 

      base16: +base16.toFixed(2),
      iva16: +iva16.toFixed(2),
      base0: +base0.toFixed(2),
      impuestos: +impuestos.toFixed(2),
      isr: +isrRetenido.toFixed(2),

      rfc_emisor: emisor?.getAttribute("Rfc") || '',
      nombre_emisor: emisor?.getAttribute("Nombre") || '',

      rfc_receptor: receptor?.getAttribute("Rfc") || '',
      nombre_receptor: receptor?.getAttribute("Nombre") || '',

      uuid: timbre?.getAttribute("UUID") || '',
      no_certificado_sat: timbre?.getAttribute("NoCertificadoSAT") || '',
      fecha_sat: timbre?.getAttribute("FechaTimbrado") || ''
    };
  }

  extract(xml: string, regex: RegExp) {
    const match = xml.match(regex);
    return match ? match[1] : '';
  }

  confirmarXML() {
  this.inventarioService.guardarXMLmanual(this.xmlPreview).subscribe({
    next: res => {
      Swal.fire('XML guardado correctamente', '', 'success');
      this.cerrarPreviewXML();

      setTimeout(() => {
        this.getXMLlista();
      }, 1500); 
    },
    error: err => {
      console.error(err);
      Swal.fire('Error al guardar el XML', '', 'error');
    }
  });
  }

  traerDatoempleado(idplantel:any) {
    this.viaticosService.Listaempleadosviaticos(idplantel).subscribe(
      res => {

        if (res == "TOKEN-EXPIRADO") {
          this.msj.tokenExpiradoCerrarSesion();
          return;
        }

        this.empleados = res;

      },
      err => console.log(err)
    );
  }
  onEmpleadoChange() {
  }
  editarPartida(index: number) {
    const partida = this.partidas[index];

    this.partidaActual = {
      clave: partida.clave,
      xmls: [...partida.xmls]
    };

    this.partidas.splice(index, 1);
  }

  eliminarPartida(index: number) {
    Swal.fire({
      title: 'Eliminar partida',
      text: '¿Deseas eliminar esta partida y sus XML?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then(res => {
      if (res.isConfirmed) {
        this.partidas.splice(index, 1);
      }
    });
  }


  cargarDatosComprobacion(viati: any) {
    this.busquedaEmpleado =
      `${viati.numempleado} - ${viati.nombre}`;
   this.viaticos = {
      plantel: viati.idplantel,
      oficio: viati.oficio,
     cargoBancario: viati.cargobancario?viati.cargobancario.split('T')[0]: null,
      subsidio: viati.subsidio,
      comisionado: '',
      motivo: viati.motivo,
      lugar: viati.lugar,
      fechaIda: viati.fechaIda?viati.fechaIda.split('T')[0]: null,
      fechaRegreso: viati.fechaRegreso?viati.fechaRegreso.split('T')[0]: null,
      importecb: viati.importecb,
      Comprobado: viati.comprobado,
      Reintegro: viati.reintegro,
     fechaReintegro: viati.fechaReintegro ? viati.fechaReintegro.split('T')[0] : null,
     buenopor: viati.buenopor
       
    };
    this.empleadoSeleccionado = {
      numpersonal: viati.numempleado,
      nombre: viati.nombre,
      curp: viati.curp,
      rfc: viati.rfc
    };

    this.partidas = viati.partidas || [];

  }
  guardarComprobacion() {

    const datos = {
      empleado: {
        numeroEmpleado: this.empleadoSeleccionado.numpersonal,
        nombre: this.empleadoSeleccionado.nombre,
        curp: this.empleadoSeleccionado.curp || null,
        rfc: this.empleadoSeleccionado.rfc || null
      },

      viaticos: {
        ...this.viaticos,
        cargoBancario: this.viaticos.cargoBancario || null,
        importecb: this.viaticos.importecb || 0,
        Comprobado: this.viaticos.Comprobado || 0,
        Reintegro: this.viaticos.Reintegro || 0,
        fechaReintegro: this.viaticos.fechaReintegro || null
      },

      partidas: this.partidas.length ? this.partidas : []
    };

    Swal.fire({
      title: '¿Guardar comprobación?',
      text: 'Verifica que la información sea correcta',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      console.log(datos)
      if (result.isConfirmed) {
        this.viaticosService.AgregarComprobacion(datos).subscribe(
          res => {

            if (res == "TOKEN-EXPIRADO") {
              this.msj.tokenExpiradoCerrarSesion();
              return;
            }

            Swal.fire({
              icon: 'success',
              title: '¡Correcto!',
              text: 'Comprobación agregada correctamente',
              timer: 1500,
              showConfirmButton: false
            }).then(() => {
              window.location.reload();
            });

          },
          err => {

            console.log(err);

            const mensaje = err?.error?.message || 'Ocurrió un error al guardar';

            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: mensaje
            });

          }
        );

      }

    });
  }
  traerDatosplantel() {
    this.inventarioService.getPlanteles(this.noplantel).subscribe(
      res => {
        if (res == "TOKEN-EXPIRADO") {
          this.msj.tokenExpiradoCerrarSesion();
          return;
        }

        this.planteles = [res];
      },
      err => console.log(err)
    );
  }
  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    Swal.fire({
      toast: true,
      position: 'top-end',
      icon: 'success',
      title: 'Copiado',
      showConfirmButton: false,
      timer: 1000
    });
  }
  calcularRestante(x: any) {
    const limite = x.maximo || x.total;

    let bueno = parseFloat(x.buenoPor);

    if (isNaN(bueno)) {
      x.restante = limite;
      return;
    }

    if (bueno < 0) {
      x.buenoPor = 0;
      x.restante = limite;
      return;
    }

    if (bueno > limite) {
      x.buenoPor = limite;
      bueno = limite;
    }

    x.restante = +(limite - bueno).toFixed(2);

    this.actualizarComprobacionYReintegro();
  }

  getTotal(xmls: any[], campo: string): number {
    return (xmls || []).reduce((acc, item) => {

      return acc + (Number(item[campo]) || 0);
    }, 0);
  }


  calcularTotales(partida: any) {
    return {
      total: this.getTotal(partida.xmls, 'total'),
      bueno: this.getTotal(partida.xmls, 'buenoPor'),
      restante: this.getTotal(partida.xmls, 'restante')
    }
  }


  
  actualizarComprobacionYReintegro() {

    const totalComprobado = this.partidas.reduce((accPartida, p) => {
      const sumaPartida = p.xmls.reduce((accXml: number, x: any) => accXml + (Number(x.buenoPor) || 0), 0);
      return accPartida + sumaPartida;
    }, 0);

    this.viaticos.Comprobado = +totalComprobado.toFixed(2);

    const importe = Number(this.viaticos.importecb) || 0;

    this.viaticos.Reintegro = +(importe - totalComprobado).toFixed(2);
  }

  validarEntrada(event: KeyboardEvent, x: any) {
    const input = event.target as HTMLInputElement;
    const limite = x.maximo || x.total;

    const teclasPermitidas = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'
    ];

    if (teclasPermitidas.includes(event.key)) return;

    if (!/[\d.]/.test(event.key)) {
      event.preventDefault();
      return;
    }

    if (
      event.key === '.' &&
      input.value.includes('.') &&
      input.selectionStart === input.selectionEnd 
    ) {
      event.preventDefault();
      return;
    }

    const inicio = input.selectionStart ?? 0;
    const fin = input.selectionEnd ?? 0;

    const nuevoValor =
      input.value.substring(0, inicio) +
      event.key +
      input.value.substring(fin);

    if (nuevoValor === '.') return;

    const numero = parseFloat(nuevoValor);

    if (!isNaN(numero) && numero > limite) {
      event.preventDefault();
    }
  }
  observacionSeleccionada: any = null;

  abrirObservacion(viati: any) {
    this.observacionSeleccionada = viati;
  }
  verComprobacion(viati: any) {

    this.modo = 'ver';
    this.idComprobacion = viati.id;
    this.viaticosService.ObtenerComprobacion(viati.id)
      .subscribe((res: any) => {
        const data = res[0];
        console.log('DETALLE COMPLETO:', data);

        this.cargarDatosComprobacion(data);
        $('#Agrexml').modal('show');
      });
  }

  editarComprobacion(viati: any) {
    this.modo = 'editar';
    this.idComprobacion = viati.id;
    this.viaticosService.ObtenerComprobacion(viati.id)
      .subscribe((res: any) => {
        const data = res[0];
        this.cargarDatosComprobacion(data); 
        $('#Agrexml').modal('show');
      });
  }

  eliminarComprobacion(viati: any) {

        Swal.fire({
          title: 'Eliminar comprobación',
          text: '¿Deseas eliminar esta comprobación?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sí, eliminar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {

          if (result.isConfirmed) {
            this.viaticosService.EliminarComprobacion(viati.id).subscribe(
              res => {

                if (res == "TOKEN-EXPIRADO") {
                  this.msj.tokenExpiradoCerrarSesion();
                  return;
                }

                Swal.fire({
                  icon: 'success',
                  title: '¡Correcto!',
                  text: 'Comprobación eliminada correctamente',
                  timer: 1500,
                  showConfirmButton: false
                }).then(() => {
                  window.location.reload();
                });

              },
              err => {

                console.log(err);

                const mensaje = err?.error?.message || 'Ocurrió un error al enviar';

                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: mensaje
                });

              }
            );
          }

        });
      

  }
  editComprobacion() {

    const datos = {
      empleado: {
        numeroEmpleado: this.empleadoSeleccionado.numpersonal,
        nombre: this.empleadoSeleccionado.nombre,
        curp: this.empleadoSeleccionado.curp || null,
        rfc: this.empleadoSeleccionado.rfc || null
      },

      viaticos: {
        ...this.viaticos,
        cargoBancario: this.viaticos.cargoBancario || null,
        importecb: this.viaticos.importecb || 0,
        Comprobado: this.viaticos.Comprobado || 0,
        Reintegro: this.viaticos.Reintegro || 0,
        fechaReintegro: this.viaticos.fechaReintegro || null
      },

      partidas: this.partidas.length ? this.partidas : []
    };

    Swal.fire({
      title: '¿Guardar comprobación?',
      text: 'Verifica que la información sea correcta',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {

      if (result.isConfirmed) {
        this.viaticosService.editarComprobacion(datos).subscribe(
          res => {

            if (res == "TOKEN-EXPIRADO") {
              this.msj.tokenExpiradoCerrarSesion();
              return;
            }

            Swal.fire({
              icon: 'success',
              title: '¡Correcto!',
              text: 'Comprobación agregada correctamente',
              timer: 1500,
              showConfirmButton: false
            }).then(() => {
              window.location.reload();
            });

          },
          err => {

            console.log(err);

            const mensaje = err?.error?.message || 'Ocurrió un error al guardar';

            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: mensaje
            });

          }
        );

      }

    });
  }
  enviarComprobacion(viati: any) {

    const datos = {
      oficio: viati.oficio
    };

    Swal.fire({
      title: '¿Enviar comprobación?',
      text: 'Se moverán las prefacturas a facturas',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, enviar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {

      if (result.isConfirmed) {
        this.viaticosService.enviarComprobacion(datos).subscribe(
          res => {

            if (res == "TOKEN-EXPIRADO") {
              this.msj.tokenExpiradoCerrarSesion();
              return;
            }

            Swal.fire({
              icon: 'success',
              title: '¡Correcto!',
              text: 'Comprobación enviada correctamente',
              timer: 1500,
              showConfirmButton: false
            }).then(() => {
              window.location.reload();
            });

          },
          err => {

            console.log(err);

            const mensaje = err?.error?.message || 'Ocurrió un error al enviar';

            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: mensaje
            });

          }
        );
      }

    });
  }
  Generaldatos() {
    this.viaticosService.getdatosgenerales(this.noplantel).subscribe(
      res => {
        this.general = res;
        this.excelGeneral();
},
      err => console.error(err)
    )
  }

  Comprobaciondatos(viati) {
    console.log(viati.id)
    this.viaticosService.getdatoscomprobacion(viati.id).subscribe(
      res => {
        this.comprobacion = res;
        console.log(this.comprobacion)
         this.excelComprobacion();
      },
      err => console.error(err)
    )
  }

  excelGeneral(): void {
    this.excelService.exportAsExcelFile(this.general, 'Excel_General');
  }
  excelComprobacion(): void {
    this.excelService.exportAsExcelFile(this.comprobacion, 'Excel_Comprobacion');
  }
  eliminarXML(viati: any) {

    Swal.fire({
      title: 'Eliminar XML',
      text: '¿Deseas eliminar este XML?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {

      if (result.isConfirmed) {

        console.log(viati)

        this.viaticosService.EliminarXML(viati).subscribe(
          res => {

            if (res == "TOKEN-EXPIRADO") {
              this.msj.tokenExpiradoCerrarSesion();
              return;
            }

            Swal.fire({
              icon: 'success',
              title: '¡Correcto!',
              text: 'XML eliminado correctamente',
              timer: 1500,
              showConfirmButton: false
            }).then(() => {
              window.location.reload();
            });

          },
          err => {

            console.log(err);

            const mensaje = err?.error?.message || 'Ocurrió un error al enviar';

            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: mensaje
            });

          }
        );
      }

    });


  }

}


